import {
    PHONE_VERIFICATION_SAVE_TOKEN_SUCCESS,
    phoneVerificationReset,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';
import {
    PHONE_VERIFICATION_MODAL_CLOSE,
    phoneVerificationModalClose,
} from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.actions';
import { all, put, takeLatest } from 'redux-saga/effects';

function* closeModal() {
    // Close modal after successful verification
    yield put(phoneVerificationModalClose());
}

function* resetVerification() {
    // Reset
    yield put(phoneVerificationReset());
}

export default function* root() {
    yield all([
        takeLatest(PHONE_VERIFICATION_SAVE_TOKEN_SUCCESS, closeModal),
        takeLatest(PHONE_VERIFICATION_MODAL_CLOSE, resetVerification),
    ]);
}
